import { faCheck, faMoon, faSunBright } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTheme } from '@karnov/kui-react'

import { useCallback } from 'react'

import {
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from 'components/DropdownMenu'

import { useTranslation } from 'services/i18n'

export const ThemeSelector = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_menu',
  })

  const { isDarkMode, currentTheme, setTheme } = useTheme()

  const onClickTheme = useCallback((theme: typeof currentTheme) => {
    setTheme(theme)
  }, [setTheme])

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <FontAwesomeIcon
          icon={isDarkMode ? faMoon : faSunBright}
          className="mr-2 w-4"
        />
        <span>{t('theme_selector.appearance')}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuItem onClick={() => onClickTheme('light')}>
          <span className="mr-2 w-4">
            {currentTheme === 'light' && <FontAwesomeIcon icon={faCheck} />}
          </span>
          {t('theme_selector.theme.light')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onClickTheme('dark')}>
          <span className="mr-2 w-4">
            {currentTheme === 'dark' && <FontAwesomeIcon icon={faCheck} />}
          </span>
          {t('theme_selector.theme.dark')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onClickTheme('system')}>
          <span className="mr-2 w-4">
            {currentTheme === 'system' && (
              <FontAwesomeIcon icon={faCheck} />
            )}
          </span>
          {t('theme_selector.theme.system')}
        </DropdownMenuItem>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
